<template>
  <div>
    <div
      v-if="picking.estado == 'B' || picking.estado == 'A'"
      class="floated-chat-btn"
      style="z-index: 1000 !important"
      @click="abrirModal()"
    >
      <i class="fas fa-check"></i>&nbsp;&nbsp;Despacho
    </div>
    <div
      class="modal fade"
      id="pickearModal"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title">Despacho de Producto</h6>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <h6 style="color: blue" v-if="producto">
              {{ producto.sku }} {{ producto.nombre }} <br />
              Pendiente:
              {{ pendiente.cant_estacion }}
            </h6>
            <small v-if="errors" class="form-text text-danger">{{
              errors.producto
            }}</small>
            <div class="form-group">
              <label for>Producto</label>
              <input
                v-if="!producto"
                @change="refreshProducto(barra)"
                class="form-control"
                placeholder="Producto"
                type="text"
                v-model="barra"
                ref="productox"
              />
              <small
                v-if="error_pickeo && error_pickeo.barra"
                class="form-text text-danger"
                >{{ error_pickeo.barra }}</small
              >
              <button
                v-if="producto"
                @click="clearProducto()"
                class="btn btn-md btn-block btn-dark"
              >
                Cambiar Producto
              </button>
            </div>
            <div class="row">
              <div class="col-sm-6" v-if="producto">
                <div class="form-group">
                  <label>Localización de estación</label>
                  <input
                    class="form-control"
                    placeholder="Localización"
                    type="text"
                    v-model="localizacion_origen"
                    ref="posicionx"
                    v-on:keyup.enter="nextInputFocus()"
                  />
                  <small
                    v-if="error_pickeo && error_pickeo.localizacion_origen"
                    class="form-text text-danger"
                    >{{ error_pickeo.localizacion_origen }}</small
                  >
                </div>
              </div>
              <div class="col-sm-6" v-if="producto">
                <div class="form-group">
                  <label for>Cantidad</label>
                  <input
                    class="form-control"
                    placeholder="Cantidad"
                    type="number"
                    step="0.01"
                    v-model="cantidad"
                    ref="cantidadx"
                  />
                  <small
                    v-if="error_pickeo && error_pickeo.cantidad"
                    class="form-text text-danger"
                    >{{ error_pickeo.cantidad }}</small
                  >
                </div>
              </div>
            </div>
            <small
              v-if="error_pickeo && error_pickeo.detail"
              class="form-text text-danger"
              >{{ error_pickeo.detail }}</small
            >
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-block btn-primary"
              type="button"
              @click="despachar()"
            >
              Despachar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {},
  props: {
    despachoe: {
      type: Object,
    },
    picking: {
    },
  },
  data() {
    return {
      errors: [],
      error: [],
      error_pickeo: [],
      barra: null,
      localizacion_origen: null,
      cantidad: null,
      lote: null,
      producto: "",
      pendiente: {
        cant_estacion: "",
        producto_id: "",
      },
    };
  },
  mounted() {
    let self = this;
    $(".modal").on("shown.bs.modal", function () {
      self.$refs.productox.focus();
    });
  },
  methods: {
    nextInputFocus() {
      this.$refs.cantidadx.focus();
    },
    abrirModal() {
      $("#pickearModal").modal("show");
    },
    clearProducto() {
      if (this.producto) {
        this.producto = "";
        this.barra = "";
      }
    },
    refreshDetalleDefault() {
      let self = this;
      self.producto = null;
      self.barra = "";
      self.cantidad = "";
      self.localizacion_origen = "";
      self.posicion = "";
      self.errors = [];
    },
    refreshProducto(barra) {
      let self = this;
      if (!barra) {
        self.errors.producto = "Este campo no puede ser nulo";
        return;
      }
      DynamicService.fetch("cat", "producto-barra", {
        barra: barra,
        activo: true,
      })
        .then((response) => {
          self.producto = response.data.results[0].producto_obj;
          self.errors.producto = "";
          this.pendienteDespachar(barra);
          setTimeout(function () {
            self.$refs.posicionx.focus();
          }, 100);
        })
        .catch((err) => {
          self.producto = null;
          self.errors.producto = "No existe producto";
        });
    },
    pendienteDespachar(barra) {
      let self = this;
      DynamicService.postActionList(
        "wms",
        "picking-despacho",
        "cantidad_pendiente_despacho",
        {
          pedido_e: self.despachoe.id,
          barra: barra,
        }
      )
        .then((response) => {
          self.pendiente = response.data[0];
        })
        .catch((err) => {});
    },
    cleanDataErrors() {
      this.error_pickeo = "";
    },
    despachar() {
      let self = this;
      DynamicService.postActionList("wms", "picking-despacho", "despachar", {
        pedido_e: self.despachoe.id,
        barra: self.barra,
        localizacion_origen: self.localizacion_origen,
        cantidad: self.cantidad,
      })
        .then((res) => {
          self.cleanDataErrors();
          $("#pickearModal").modal("hide");
          self.refreshDetalleDefault();
          self.data = {
            error_pickeo: null,
            barra: null,
            localizacion_origen: null,
            cantidad: null,
            lote: null,
          };
          this.$emit("refreshCurrent");
        })
        .catch((err) => {
          console.log(err.response.data);
          self.error_pickeo = err.response.data;
          if (err.response.data.detail) {
            Notifications.alert.error(
              "Despachar producto a cliente",
              err.response.data.detail
            );
          }
        });
    },
  },
};
</script>
